import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconAngleDown: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <path
            fill="currentColor"
            d="M10.586 16.586c.72-.721 1.855-.777 2.64-.167l.188.167L24 27.17l10.586-10.584c.72-.721 1.855-.777 2.64-.167l.188.167c.721.72.777 1.855.167 2.64l-.167.188-12 12c-.72.721-1.855.777-2.64.167l-.188-.167-12-12c-.781-.78-.781-2.047 0-2.828z"
          />
        </svg>
      </div>
    </div>
  )
}
export default IconAngleDown
